import { render, staticRenderFns } from "./MyAdminCenters.vue?vue&type=template&id=4a4e1b1f&lang=pug&"
import script from "./MyAdminCenters.vue?vue&type=script&lang=js&"
export * from "./MyAdminCenters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports